import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NativeService } from 'src/app/core/native/native.service';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.css'],
})

export class ToolbarComponent {

  @Input()
  showSyncIcon: boolean = true;
  
  // 同期ベント
  @Output() 
  syncEvent = new EventEmitter<void>();

  constructor(
    private nativeService: NativeService,
  ) {
  }

  ngOnInit(): void {
  }

  scanDevices(): void {
    console.log("start scanDevices");
    this.nativeService.scanDevices();
  }

  sync(): void {
    this.syncEvent.emit();
  }

}
